import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizeGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  checkAuthentication(returnUrl: string): boolean | UrlTree {
    const loggedIn = this.authService.isLoggedIn();

    if (!loggedIn) {
      return this.router.createUrlTree(['/auth/login'], {
        queryParams: { returnUrl },
      });
    }
    return true;
  }

  // Impede que o modulo inteiro seja carregado
  // É carregado primeiro
  // False não retorna o modulo
  canLoad(
    route: Route,
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const returnUrl = route.path ? `/${route.path}` : '/';
    return this.checkAuthentication(returnUrl);
  }

  // ActivatedRouteSnapshot: Copia da rota ativada
  // RouterStateSnapshot: Arvore de ActivatedRouteSnapshot possui todo o caminho das rotas ativadas
  canActivate(
    activateRoute: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot,
  ): boolean | UrlTree {
    const returnUrl = routerState.url || '/';
    return this.checkAuthentication(returnUrl);
  }

  canActivateChild(
    activateRoute: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot,
  ): boolean | UrlTree {
    return this.canActivate(activateRoute, routerState);
  }
}
